<template>
    <form-row title="Gas" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_gas"
                v-model="has_gas"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_gas" class="pt-6 pb-2">
                <div class="flex">
                    <input-money
                        class="mr-6"
                        label="Cost"
                        placeholder="Cost"
                        name="gas_cost"
                        v-model="gas_cost"
                        :read_only="read_only"
                    />

                    <input-text
                        class="mr-6"
                        label="Building sq.ft."
                        v-model="square_feet"
                        :read_only="true"
                    />

                    <input-money
                        label="Cost/sq.ft."
                        :value="cost_per_square_foot"
                        :read_only="true"
                    />
                </div>

                <input-text
                    class="w-full pt-3"
                    label="Contract company"
                    placeholder="Company name"
                    name="gas_company"
                    :value="commercial.gas_company"
                    :read_only="read_only"
                />

                <input-textarea
                    class="w-full pt-3"
                    placeholder="Contact information"
                    name="gas_company_contact_info"
                    :value="commercial.gas_company_contact_info"
                    :rows="3"
                    :read_only="read_only"
                />

                <div class="border-t border-gray-400 mt-8 py-6">
                    <input-text
                        label="Where is it located now?"
                        class="w-full"
                        name="utilities_gas"
                        :value="commercial.utilities_gas"
                        :read_only="read_only"
                    />

                    <buyer-seller-city
                        label="Who is Responsible for bringing it to the Property Line?"
                        class="mt-5"
                        field="utilities_gas_who_responsible"
                        :value="commercial.utilities_gas_who_responsible"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerCity from '../buyer-seller-city.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerCity,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_gas: this.commercial.has_gas,
            gas_cost: this.commercial.gas_cost,
        }
    },

    computed: {
        square_feet: {
            get() {
                return store.state.square_feet || null;
            },
            set(val) {
                store.state.square_feet = val;
            },
        },
        cost_per_square_foot() {
            return this.gas_cost && this.square_feet
                ? Math.round(this.formatMoney(this.gas_cost) / parseInt(this.square_feet) * 100) / 100
                : null;
        },
    },
}
</script>
